import styled from "styled-components";

export const FormAlertGroup = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
`;
